import App from './App'

export default class Environment {

  constructor(environment = {}) {
    this.id = environment.id || null
    this.type = environment.type || ''
    this.is_production = environment.is_production || false
    this.client_id = environment.client_id || null
    this.user_id = environment.user_id || null
    this.app_id = environment.app_id || null
    this.app = environment.app || new App
    this.name = environment.name || ''
    this.attributes = environment.attributes || []
    this.vulnerabilities = environment.vulnerabilities || []
    this.software = environment.software || []
    this.updated_at = environment.updated_at || null
    this.created_at = environment.created_at || null
    this.tls_certificate = environment.tls_certificate || null
    this.public_url = environment.public_url || null
    this.is_production = environment.is_production || false
    this.distribution = environment.distribution || {}
  }

  mutations() {
    return {
      setEnvironment: (state, environment) => state.environment = new Environment(environment),
      clearEnvironment: (state) => state.environment = new Environment(),
      updateName: (state, name) => state.environment.name = name,
      updatePublicUrl: (state, url) => state.environment.public_url = url,
      makeProduction: (state) => state.environment.is_production = true
    }
  }
}